"use client";

import * as React from "react";
import { cn } from "lib/utils";

/**
 * ShadCN-style Textarea component
 * Matches your theming system (focus ring, dark mode, smooth transitions)
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        // Base sizing & layout
        "w-full min-h-[100px] rounded-lg px-3 py-2 text-sm resize-y",
        // Visual base
        "border border-line-strong bg-transparent text-content placeholder-gray-400",
        // Interaction & transitions
        "transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
        // Hover & disabled
        "hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed",
        // Dark mode
        "dark:border-dark-500 dark:bg-dark-700 dark:text-gray-200 dark:placeholder-gray-500 dark:focus:border-blue-400 dark:focus:ring-blue-400 dark:hover:border-dark-400",
        className
      )}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
